import React, { useEffect } from 'react';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import Logo from '../Components/Logo';
import { CHATAREA } from '../Routes/constURL';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from "@mui/material/styles";

const Howitworks = () => {
    const { t } = useTranslation(); // Use translation hook
    const navigate = useNavigate()
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints?.down("sm"));
    useEffect(() => {
        window.scroll(0,0)
      }, [])
    return (
        <Box sx={{mt:3.7}}>
            <Logo />
            <div style={{ textAlign: 'center', paddingTop: '9rem', paddingBottom: '5rem',minHeight:'75vh' }}>
                <Typography style={{ fontWeight: 500 ,lineHeight:isMobile?1:0,fontSize:isMobile?"24px":"46px"}}>
                    {t('howitworks.title')}
                </Typography>
                <Typography variant="h4" style={{  marginTop: '1rem', marginBottom: '2rem',fontWeight: 500, fontSize:isMobile?"24px":"46px"}}>
                {t('howitworks.desc')}
                </Typography>
                <Button
                    variant="contained"
                    sx={{
                        background: 'linear-gradient(to right, rgb(53, 66, 255) 0%,#B87DFF, rgb(85, 247, 255) 100%)',
                        color: '#fff',
                        borderRadius: '30px',
                        padding: '10px 30px',
                        textTransform: 'none',
                        fontSize: {xs:'14px',md:'20px'},
                        fontWeight:600,
                        boxShadow:"none",
                        width:{xs:'50%',md:'20%'},
                        "&:hover":{
                            boxShadow:"none"
                        }
                    }}
                    onClick={()=>navigate(CHATAREA)}
                >
                    {t('howitworks.button')}
                    </Button>
            </div>
        </Box>
    );
};

export default Howitworks;
